export default __webpack_public_path__ + "static/media/24 Heart.48013d59.gif";